import React from 'react';
import { Link } from 'react-router-dom';

// Landing'e taşınacak bölüm. "Her malzemeyi elle mi gireceğim?" itirazına cevap.
// Site renkleriyle (primary=kırmızı), responsive: masaüstü yatay stepper,
// mobil 2.5sn otomatik dönen carousel (basınca durur). Telefon ekranları sade
// HTML/CSS mockup — sonra istersen gerçek screenshot'la değiştiririz.

function PhoneFrame({ children }) {
  return (
    <div className="mx-auto w-full max-w-[210px] rounded-[1.75rem] border-[6px] border-slate-900 bg-white shadow-xl dark:border-slate-700">
      <div className="relative h-5 rounded-t-[1.25rem] bg-white">
        <span className="absolute left-1/2 top-1.5 h-1.5 w-12 -translate-x-1/2 rounded-full bg-slate-200" />
      </div>
      <div className="px-3 pb-4 pt-1 text-left">{children}</div>
    </div>
  );
}

const PROFILES = [
  { icon: 'work', label: 'Yoğun Çalışan' },
  { icon: 'school', label: 'Öğrenci' },
  { icon: 'home', label: 'Evde Pişiren' },
  { icon: 'elderly', label: 'Emekli' }
];

const STARTER = [
  ['Yumurta', '10 adet'],
  ['Tavuk Göğsü', '500 g'],
  ['Makarna', '500 g'],
  ['Pirinç', '1 kg']
];

const KITCHEN = [
  ['Yumurta', '10 adet'],
  ['Tavuk Göğsü', '500 g'],
  ['Süt', '1 L']
];

const PREMIUM_KITCHENS = ['Alakart Mutfağı', 'Diyet Mutfağı', 'Sporcu Mutfağı', 've daha fazlası…'];

// --- Adım görselleri ---
function VisualProfile() {
  return (
    <PhoneFrame>
      <p className="text-[11px] font-bold text-slate-900">Yaşam tarzını seç</p>
      <div className="mt-2 space-y-1.5">
        {PROFILES.map((p) => (
          <div key={p.label} className="flex items-center gap-2 rounded-lg border border-slate-200 px-2 py-1.5">
            <span className="material-symbols-outlined text-[16px] text-primary">{p.icon}</span>
            <span className="text-[10px] font-semibold text-slate-700">{p.label}</span>
            <span className="material-symbols-outlined ml-auto text-[14px] text-slate-300">chevron_right</span>
          </div>
        ))}
      </div>
    </PhoneFrame>
  );
}

function VisualStarter() {
  return (
    <PhoneFrame>
      <p className="text-[11px] font-bold text-slate-900">Başlangıç Mutfağın Hazır!</p>
      <p className="mt-0.5 text-[8px] text-slate-400">Temel ihtiyaçların tahmin edildi</p>
      <div className="mt-2 space-y-1">
        {STARTER.map(([name, qty]) => (
          <div key={name} className="flex items-center justify-between rounded-md bg-slate-50 px-2 py-1">
            <span className="text-[10px] font-semibold text-slate-700">{name}</span>
            <span className="text-[9px] font-bold text-slate-500">{qty}</span>
          </div>
        ))}
      </div>
    </PhoneFrame>
  );
}

function VisualKitchen() {
  return (
    <PhoneFrame>
      <div className="flex items-center justify-between">
        <p className="text-[11px] font-bold text-slate-900">Mutfağım</p>
        <span className="material-symbols-outlined text-[14px] text-slate-400">edit</span>
      </div>
      <div className="mt-1.5 flex items-center justify-between rounded-md bg-emerald-50 px-2 py-1">
        <span className="text-[9px] font-semibold text-emerald-700">Mutfak Değeri</span>
        <span className="text-[10px] font-black text-emerald-700">₺ 850</span>
      </div>
      <div className="mt-2 space-y-1.5">
        {KITCHEN.map(([name, qty]) => (
          <div key={name} className="flex items-center gap-1.5 rounded-md border border-slate-200 px-2 py-1">
            <span className="text-[10px] font-semibold text-slate-700">{name}</span>
            <span className="ml-auto flex items-center gap-1 text-[9px] text-slate-400">
              <span className="flex h-3.5 w-3.5 items-center justify-center rounded bg-slate-100">−</span>
              {qty}
              <span className="flex h-3.5 w-3.5 items-center justify-center rounded bg-slate-100">+</span>
            </span>
          </div>
        ))}
      </div>
      <div className="mt-2 rounded-md bg-primary py-1 text-center text-[10px] font-bold text-white">+ Ürün Ekle</div>
    </PhoneFrame>
  );
}

function VisualLock() {
  return (
    <div className="mx-auto flex w-full max-w-[210px] flex-col items-center rounded-2xl border border-amber-200 bg-amber-50/60 p-5 dark:border-amber-900/40 dark:bg-amber-900/10">
      <span className="material-symbols-outlined text-[44px] text-amber-500">lock</span>
      <p className="mt-2 text-center text-[11px] font-bold text-amber-700 dark:text-amber-300">Premium mutfaklar kapalı</p>
      <p className="mt-1 text-center text-[10px] text-slate-500 dark:text-slate-400">Ama çekirdek tüm gücüyle açık</p>
      <div className="mt-3 space-y-1 text-[10px] font-semibold text-slate-600 dark:text-slate-300">
        {['Stok Gir', 'Tarif Öner', 'Kurtar & Değerlendir', 'Alışveriş Listesi'].map((x) => (
          <div key={x} className="flex items-center gap-1.5">
            <span className="material-symbols-outlined text-[14px] text-emerald-500">check_circle</span>
            {x}
          </div>
        ))}
      </div>
    </div>
  );
}

function VisualUnlock() {
  return (
    <div className="mx-auto flex w-full max-w-[210px] flex-col items-center rounded-2xl border border-emerald-200 bg-emerald-50/60 p-5 dark:border-emerald-900/40 dark:bg-emerald-900/10">
      <span className="material-symbols-outlined text-[44px] text-emerald-500">celebration</span>
      <p className="mt-2 text-center text-[11px] font-bold text-emerald-700 dark:text-emerald-300">Premium mutfaklar açıldı!</p>
      <p className="mt-1 text-center text-[10px] text-slate-500 dark:text-slate-400">7 gün boyunca tam erişim</p>
      <div className="mt-3 flex flex-wrap justify-center gap-1">
        {PREMIUM_KITCHENS.map((k) => (
          <span key={k} className="rounded-full border border-emerald-300 bg-white px-2 py-0.5 text-[9px] font-semibold text-emerald-700 dark:bg-slate-900 dark:text-emerald-300">
            {k}
          </span>
        ))}
      </div>
    </div>
  );
}

const STEPS = [
  { n: 1, label: 'SENİ TANIYALIM', text: 'İlk kurulumda yaşam tarzını sorarız.', Visual: VisualProfile },
  { n: 2, label: 'TEMEL İHTİYAÇLARINI TAHMİN EDERİZ', text: 'Profiline göre başlangıç stoğunu biz hazırlarız; sıfırdan tek tek girmezsin.', Visual: VisualStarter },
  { n: 3, label: 'MUTFAĞIN SENİN ELİNDE', text: 'Beğenmezsen değiştirirsin; gerçek mutfağın seninle şekillenir.', Visual: VisualKitchen },
  { n: 4, label: 'İLK 7 GÜN: TEMEL AKIŞ', text: 'Premium mutfaklar kapalıdır — önce temeli öğrenmen için.', Visual: VisualLock },
  { n: 5, label: '7. GÜNDEN SONRA: 7 GÜN TAM ERİŞİM', text: 'Premium mutfaklar açılır; 7 gün boyunca tüm özellikleri denersin.', Visual: VisualUnlock }
];

function StepCard({ step, mobile = false }) {
  const { Visual } = step;
  return (
    <div className={`flex flex-col rounded-2xl border border-slate-200 bg-white p-4 dark:border-slate-800 dark:bg-slate-900 ${mobile ? 'min-h-[56vh]' : 'flex-1'}`}>
      <div className="flex items-center gap-2">
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-black text-white">{step.n}</span>
        <h3 className="font-display text-[11px] font-black uppercase leading-tight tracking-wide text-slate-900 dark:text-white">{step.label}</h3>
      </div>
      <p className="mt-2 text-xs leading-relaxed text-slate-500 dark:text-slate-400">{step.text}</p>
      <div className="mt-4 flex flex-1 items-center justify-center">
        <div className="w-full"><Visual /></div>
      </div>
    </div>
  );
}

function MobileCarousel({ steps }) {
  const [active, setActive] = React.useState(0);
  const [paused, setPaused] = React.useState(false);
  const [dragX, setDragX] = React.useState(0);
  const [dragging, setDragging] = React.useState(false);
  const startXRef = React.useRef(0);

  React.useEffect(() => {
    if (paused) return undefined;
    const id = setInterval(() => setActive((a) => (a + 1) % steps.length), 2500);
    return () => clearInterval(id);
  }, [paused, steps.length]);

  const handleStart = (x) => {
    startXRef.current = x;
    setDragging(true);
    setPaused(true); // sürükleme/dokunma otomatik geçişi durdurur
  };
  const handleMove = (x) => {
    if (!dragging) return;
    setDragX(x - startXRef.current);
  };
  const handleEnd = () => {
    if (!dragging) return;
    const threshold = 45; // px
    if (dragX <= -threshold && active < steps.length - 1) setActive(active + 1);
    else if (dragX >= threshold && active > 0) setActive(active - 1);
    setDragX(0);
    setDragging(false);
  };

  return (
    <div className="select-none md:hidden">
      <div
        className="overflow-hidden"
        style={{ touchAction: 'pan-y' }}
        onTouchStart={(e) => handleStart(e.touches[0].clientX)}
        onTouchMove={(e) => handleMove(e.touches[0].clientX)}
        onTouchEnd={handleEnd}
      >
        <div
          className={`flex ${dragging ? '' : 'transition-transform duration-500 ease-out'}`}
          style={{ transform: `translateX(-${active * 100}%) translateX(${dragX}px)` }}
        >
          {steps.map((s) => (
            <div key={s.n} className="w-full shrink-0 px-1">
              <StepCard step={s} mobile />
            </div>
          ))}
        </div>
      </div>
      <div className="mt-4 flex items-center justify-center gap-2">
        {steps.map((s, i) => (
          <button
            key={s.n}
            type="button"
            onClick={() => { setActive(i); setPaused(true); }}
            aria-label={`Adım ${i + 1}`}
            className={`h-2 rounded-full transition-all ${i === active ? 'w-6 bg-primary' : 'w-2 bg-slate-300 dark:bg-slate-600'}`}
          />
        ))}
      </div>
    </div>
  );
}

export default function OnboardingJourney() {
  return (
    <section className="font-body w-full px-4 py-12">
      {/* Başlık — itiraza cevap */}
      <div className="mx-auto max-w-3xl text-center">
        <p className="font-label text-xs font-bold uppercase tracking-[0.2em] text-primary">Her malzemeyi elle mi gireceğim?</p>
        <h2 className="mt-3 font-display text-2xl font-black leading-tight text-slate-900 dark:text-white md:text-4xl">
          BBTV ile mutfağını 2 dakikada kur, mutfağının değerini (₺) hemen gör.
        </h2>
        <p className="mt-3 text-base text-slate-600 dark:text-slate-300">
          Seni <span className="font-bold text-primary">tanır</span>, mutfağınla <span className="font-bold text-primary">başlar</span>, zamanla <span className="font-bold text-primary">gerçek mutfağına</span> dönüşür.
        </p>
      </div>

      {/* Masaüstü: yatay stepper */}
      <div className="mx-auto mt-10 hidden max-w-6xl md:flex md:items-stretch md:gap-3">
        {STEPS.map((step, i) => (
          <React.Fragment key={step.n}>
            <StepCard step={step} />
            {i < STEPS.length - 1 ? (
              <div className="flex items-center justify-center text-primary">
                <span className="material-symbols-outlined">arrow_forward</span>
              </div>
            ) : null}
          </React.Fragment>
        ))}
      </div>

      {/* Mobil: 5 sn otomatik carousel (basınca durur) */}
      <div className="mx-auto mt-8 max-w-md">
        <MobileCarousel steps={STEPS} />
      </div>

      {/* CTA */}
      <div className="mt-8 text-center">
        <Link to="/nasil-calisir#baslangic" className="inline-block rounded-lg bg-primary px-7 py-3 text-sm font-bold uppercase tracking-wide text-white hover:bg-primary-dark">
          Nasıl Çalışır? Detaylı Anlat
        </Link>
      </div>
    </section>
  );
}
